export default __webpack_public_path__ + "static/media/blockchain.088c9977.webp";